import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { APP_NAME } from '@zet/end-points'
import { zetApi } from '@zet/network'
import storageUtil from '@zet/utils/storage'

import { IExperiments } from '../types'
import { getExperimentsFallBackData } from '../utils'

const getExperiments = async () => {
  const p1 = new Promise<IExperiments>((resolve) => {
    setTimeout(() => {
      resolve(getExperimentsFallBackData())
    }, 5000)
  })

  const p2 = new Promise<IExperiments>((resolve, reject) => {
    return zetApi
      .get<IExperiments>('experiment/evaluate')
      .then(({ data }) => {
        const experiments = {
          ...data?.data,
          UI_isNewUserTasks: data?.data?.UI_isHomepageDecluttered,
          UI_IsNewRecommendation:
            data?.data?.UI_DynamicApprovalRateAndRejectionPayout &&
            data?.data?.UI_DynamicApprovalRateAndRejectionPayout !==
              'NoDynamicApprovalAndRejection',
          UI_isRaiseComplaint:
            APP_NAME !== MY_TEAMS_ADVISOR
              ? data?.data?.UI_isRaiseComplaint
              : false,
        }
        storageUtil.saveObject('experiments', experiments)
        resolve(experiments)
      })
      .catch((error) => {
        reject(error)
      })
  })

  const experiments = await Promise.race<IExperiments>([p1, p2])
  return experiments
}

export { getExperiments }
